import { VolumeIllustrationModel } from "api"
import styled from "styled-components"
import TabsComponent from "../../reusable/TabsComponent/TabsComponent"

const StyledSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 60px;
  padding: 80px 0;
  background-color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 18px 0 32px;
  }
`

type IllustrateSizeSectionSectionType = {
  illustrateSize: VolumeIllustrationModel[]
}

const IllustrateSizeSection = ({
  illustrateSize,
}: IllustrateSizeSectionSectionType) => {
  return (
    <StyledSectionWrapper>
      <TabsComponent data={illustrateSize}></TabsComponent>
    </StyledSectionWrapper>
  )
}

export default IllustrateSizeSection
